import { CircleCheckIcon } from "lucide-react";

import { Row } from "@/components/Row";
import { useToast } from "@/hooks/use-toast";

export const useSuccessToast = () => {
  const { toast } = useToast();

  return ({ description }: { description: string }) => {
    toast({
      description: (
        <Row className="items-center gap-2">
          <CircleCheckIcon className="h-6 w-6 fill-primary-900 text-white" />
          {description}
        </Row>
      ),
    });
  };
};
